import React from 'react';

interface IContentContainerProps {
	children?: React.ReactNode;
}

export const ContentContainer = ({ children }: IContentContainerProps) => (
	<main className="w-full pb-3 mx-auto sm:mt-5 lg:mt-6 xl:mt-0">{children}</main>
);
